<template>
  <div>
    <CommonForm @search="formSearch" :form-json="formjson" />
    <CommonTable
      ref="table"
      :data="tableData"
      :total="total"
      @change="handleTableChange"
      :operation="operation"
      @operation="handleOperation"
      :table-json="tablejson"
    >
    </CommonTable>
    <ShadowHistory
      v-if="historyVisible"
      :visible.sync="historyVisible"
      :row="row"
      @refresh="formSearch"
    />
  </div>
</template>

<script>
import ShadowHistory from './ShadowHistory'
import tablejson from './Model/Tablejson.Index'
import formjson from './Model/Formjson.Index'
import formTableMixin from '@/mixins/formTableMixin'
import { getRoleByOperationCode } from '@/authorized'
export default {
  mixins: [formTableMixin],
  components: {
    ShadowHistory
  },
  props: {
    productKey: {
      type: String,
      default: ''
    },
    roleList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      tablejson,
      formjson,
      operation: [
        {
          name: this.$t('Device.historyData'),
          icon: 'icon-data_statistics_light',
          type: 'history',
          width: 100,
          hide: () => {
            return !this.historyRole
          }
        }
      ],
      queryApi: this.$api.device.device_shadow_list,
      historyVisible: false,
      row: {}
    }
  },
  computed: {
    historyRole() {
      let role = getRoleByOperationCode(this.roleList, 'history')
      return role ? role.isPermission == 'Y' : false
    }
  },
  watch: {
    productKey() {
      this.formSearch()
    }
  },
  methods: {
    formSearch(data) {
      if (!this.productKey) return
      const params = {
        ...data,
        deviceId: this.$route.query.id,
        productKey: this.productKey
      }
      this.search(params, null, this.queryApi)
    },
    handleHistory(row) {
      this.row = row
      this.historyVisible = true
    },
    handleOperation(data) {
      const { type, row } = data
      switch (type) {
        case 'history':
          this.handleHistory(row)
          break
      }
    }
  }
}
</script>
